import GridPoint from './Gridpoint';

const TableHead = () => (
    <div className="table-head desktop-only">
        <GridPoint />
    </div>
);

export default TableHead;
